import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { signupWithSocial, isUsernameAvailable } from 'src/modules/shared/auth/actions';
import { closeModal } from 'src/modules/shared/modal/actions';
import SignupSurvey from 'src/modules/shared/modal/components/signup/signupSurvey';

class CreateAccountSocialSignupBox extends React.Component {
  static propTypes = {
    authdata: PropTypes.object.isRequired,
    signupContext: PropTypes.object.isRequired,
  }

  onSubmit= async ({ username }) => {
    const { authdata, signupWithSocial, signupContext, onSuccess } = this.props;
    await signupWithSocial({...authdata, username}, !!authdata.googleUserId ? 'Google' : 'Facebook', signupContext);
    onSuccess();
  }

  render() {
    return (
      <SignupSurvey
        closeModal={this.props.closeModal}
        onFinish={this.onSubmit}
      />
    );
  }
}

export default connect(null, { signupWithSocial, isUsernameAvailable, closeModal })(CreateAccountSocialSignupBox);




// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/createAccountSocial.js